/**
 * Registry location for the SpecificAI inference Helm chart.
 *
 * Still the internal ECR registry: the public GHCR channel
 * (oci://ghcr.io/marketplace-specificai/specificai-inference) exists but only
 * carries a bootstrap placeholder until the inference chart's first real
 * promote (docs/operations/chart-promotion-registry-conventions.md, "Public
 * GHCR channel"). Flip this ref once that has run and been verified.
 */

export const INFERENCE_CHART_OCI_REF =
    'oci://390402537632.dkr.ecr.us-west-2.amazonaws.com/specificai/specificai-inference';

export const INFERENCE_VALUES_TEMPLATE_URL =
    'https://github.com/marketplace-specificai/specificai-inference/blob/main/specificai-inference-values-template.yaml';
